import DashboardOTM from "../components/DashboardOTM/Home";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <DashboardOTM/>
    </div>
  );
}
